export default __webpack_public_path__ + "static/media/iot-python.b4bcc805.webp";